module.exports = __webpack_public_path__ + "img/icon-add.cc376958.svg";